import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetNavigationHeaderResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {useTrackFeature} from '@aboutyou/tracking';
import {Tabs} from '@aboutyou/ui-components';
import React, {useMemo} from 'react';
import styled from 'styled-components';
import {usePotentialFilters} from '../../../features/ProductStream/utils';
import {useSelectedDiscount} from '../../Campaigns/SelectedDiscounts/useSelectedDiscount';
import {useSelectedDiscountColor} from '../../Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {useHeaderData} from '../Header/helpers';
import {
  DiscountParamValue,
  useIsDiscountSelected,
} from '../utils/useIsDiscountSelected';

const ViewComponent = ({tabs}: GetNavigationHeaderResponse) => {
  const selectedDiscount = useSelectedDiscount();
  const trackFeature = useTrackFeature();
  const {setFilters} = usePotentialFilters();
  const isDiscountSelected = useIsDiscountSelected();
  const discountColor = useSelectedDiscountColor();

  const mappedTabs = useMemo(() => {
    const mappedValue = tabs.map((tab, index) => {
      return {
        label: tab.label,
        value: index === 0 ? DiscountParamValue.all : DiscountParamValue.deals,
        count: index === 0 ? undefined : tab.productCount,
        backgroundColour:
          index === 1 ? discountColor : tab.badgeBackgroundColor?.hex,
      };
    });
    return mappedValue;
  }, [selectedDiscount, tabs]);

  const onTabClick = (args: string | number) => {
    trackFeature({
      eventType: 'click',
      label: args === DiscountParamValue.all ? 'all_items' : 'deal_items',
    });

    const filters: {
      filterId: string;
      filterSection: string;
      label: FilterLabels;
      shouldTrackImmediately: boolean;
    }[] = [];

    const conditions =
      args === DiscountParamValue.all
        ? [{filterId: 'false', filterSection: 'hasCampaignReduction'}]
        : [
            {filterId: 'false', filterSection: 'sale'},
            {filterId: 'true', filterSection: 'hasCampaignReduction'},
          ];

    conditions.forEach(condition =>
      filters.push({
        filterId: condition.filterId,
        filterSection: condition.filterSection,
        label: 'quick_filters' as FilterLabels,
        shouldTrackImmediately: true,
      }),
    );
    setFilters(filters);
  };

  return (
    <StyledTabs
      onTabClick={onTabClick}
      dataTestId="DiscountTabs"
      selectedTabValue={
        isDiscountSelected ? DiscountParamValue.deals : DiscountParamValue.all
      }
      tabs={mappedTabs}
      highlightColorOnActive
    />
  );
};

export const CategoryDiscountTabs = () => {
  return (
    <DataFetcher request={useHeaderData()} View={ViewComponent} Error={null} />
  );
};

const StyledTabs = styled(Tabs)<{largerMarginBottom?: boolean}>`
  margin-bottom: -5px;
  padding-inline: 1rem;
`;
